import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'center',
    },
    label: {
      fontSize: theme.typography.pxToRem(10),
      lineHeight: theme.typography.pxToRem(16),
      color: COLORS.gray.gray40,
    },
    button: {
      minWidth: 'auto',
      height: 'auto',
      marginLeft: theme.spacing(0.5),
      padding: theme.spacing(0),
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(16),
      fontWeight: theme.typography.fontWeightMedium,
      color: COLORS.primary.default,
      whiteSpace: 'nowrap',

      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    menuPaper: {
      width: 300,
      maxHeight: 200,
      marginTop: theme.spacing(0.5),
    },
  }),
  { name: 'SelectGenerationTool' }
);
